import { ApplicantTypeCodes } from '../../../direct-entry/applicant-info/constants/applicant-type-codes';

/**
 * Constructs the licensee name from the provided licensee information.
 * Returns the full name for individuals, or the entity name for organizations.
 *
 * @param licenseeFirstName The first name of the licensee.
 * @param licenseeLastName The last name of the licensee.
 * @param licenseeEntityName The entity name of the licensee.
 * @param applicantTypeCode The applicant type code indicating individual or organization.
 * @returns The constructed licensee name, or null if applicant type code is not available.
 */
export function constructLicenseeName(
    licenseeFirstName: string | null,
    licenseeLastName: string | null,
    licenseeEntityName: string | null,
    applicantTypeCode: string | null,
): string | null {
    if (!applicantTypeCode) {
        return null;
    }

    if (applicantTypeCode === ApplicantTypeCodes.individual) {
        return [licenseeFirstName, licenseeLastName].filter(Boolean).join(' ');
    }

    return licenseeEntityName;
}
